import Vue from 'vue';
import Router from 'vue-router';
import { result } from 'lodash';
import { handleTokenRequest, routeLoginPage } from '@/modules/sso/helpers';
import { userTimeSpend } from '@/shared/apis';
import tokenStorage from '../helpers/tokenStorage';
import store from '../store';

import options from './options';

Vue.use(Router);

const { NODE_ENV } = process.env;
const router = new Router(options);
let interval;

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = result(store, 'state.Auth.isAuthenticated');

  const tokens = tokenStorage.get();
  const accessToken = result(tokens, 'access_token', []);
  let timeSpend = 0;

  // User time spend log
  if (requiresAuth && accessToken.length && process.env.NODE_ENV !== 'development') {
    const per = 1000; // a sec

    clearInterval(interval);

    interval = setInterval(() => {
      if (document.visibilityState === 'visible') timeSpend++;

      if (timeSpend >= 60) {
        userTimeSpend({
          time: 1,
          project_id: to.params.projectId,
          module: to.name,
          path: to.path
        });

        timeSpend = 0;
      }
    }, per);
  } else if (interval) {
    clearInterval(interval);
    timeSpend = 0;
    interval = false;
  }

  // Login screen adjustment
  if (to.name === 'login' && NODE_ENV !== 'development') {
    next('/');
  }

  if (requiresAuth && accessToken.length === 0 && !isAuthenticated) {
    handleTokenRequest().then((t) => {
      if (t) {
        window.location.reload();
      } else {
        routeLoginPage(window.location.href);
      }
    }).catch(() => {
      routeLoginPage(window.location.href);
    });
  } else {
    next();
  }
});

export default router;
